import React from 'react';

import { ContractList } from '@/api/rest/resources/types/contract';
import { SignedInPageLayout } from '@/layout/signed-in-page';
import { useMenuItems } from '@/pages/shared/hooks/useMenuItems';

import { WithContracts } from './components/with-contracts/WithContracts';
import { WithoutContracts } from './components/without-contracts/WithoutContracts';
import { useLandstewardContract } from './hooks/useLandstewardContract';

export const LandstewardInvestmentsPage = () => {
  const { data } = useLandstewardContract();
  const menuItems = useMenuItems();

  return (
    <SignedInPageLayout items={menuItems} withCustomContentContainer>
      <Body contracts={data.results} />
    </SignedInPageLayout>
  );
};

export const Body: React.FC<{ contracts: ContractList[] }> = ({ contracts }) => {
  if (contracts.length === 0) {
    return <WithoutContracts />;
  }

  return <WithContracts />;
};
